import script from "./TerminationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminationsTable.vue?vue&type=script&setup=true&lang=js"

import "./TerminationsTable.vue?vue&type=style&index=0&id=edb84b34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edb84b34"]])

export default __exports__